<template>
  <div class="form-box">
    <el-form v-if="params.phone" :model="scopedForm" status-icon :rules="rules" ref="scopedForm" label-width="118px"
      autocomplete="off">
      <el-form-item :label="$privatization?'账号：':'手机号：'" prop="oldPhone">
        <el-input type="" v-model="scopedForm.oldPhone" autocomplete="off" disabled="disabled"></el-input>
      </el-form-item>
      <div v-if="!$privatization">
        <el-form-item label="短信验证码：" prop="numCode">
          <el-input v-model="scopedForm.numCode" :class="['numCode', {load: validCode._load}]" autocomplete="off">
          </el-input>
          <el-button class="numCodeBtn" :loading="validCode._load" @click="sendSMS" :disabled="scopedForm.disabled">
            {{validCode._html}}</el-button>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" v-model="scopedForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
          <el-input type="password" v-model="scopedForm.checkPass" autocomplete="new-password"></el-input>
        </el-form-item>
      </div>
      <div v-if="$privatization">
        <el-form-item label="旧密码：" prop="pass">
          <el-input type="password" v-model="scopedForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" v-model="scopedForm.checkPass" autocomplete="new-password"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-form v-if="params.email && !params.phone" :model="emailForm" status-icon :rules="emailRules" ref="emailForm" label-width="118px"
      autocomplete="off">
      <el-form-item :label="$privatization?'账号：':'邮箱：'" prop="oldPhone">
        <el-input type="" v-model="emailForm.email" autocomplete="off" disabled="disabled"></el-input>
      </el-form-item>
      <div v-if="!$privatization && appName !=='shanghai'">
        <el-form-item label="短信验证码：" prop="numCode">
          <el-input v-model="emailForm.numCode" :class="['numCode', {load: validCode._load}]" autocomplete="off">
          </el-input>
          <el-button class="numCodeBtn" :loading="validCode._load" @click="sendSMS" :disabled="emailForm.disabled">
            {{validCode._html}}</el-button>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" v-model="emailForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
          <el-input type="password" v-model="emailForm.checkPass" autocomplete="new-password"></el-input>
        </el-form-item>
      </div>
      <div v-if="$privatization">
        <el-form-item label="旧密码：" prop="pass">
          <el-input type="password" v-model="emailForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" v-model="emailForm.checkPass" autocomplete="new-password"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "editPasswprd",
  props: ["ifForm", "isCall", "params"],
  data () {
    var oldPassFun = (rule, value, callback) => {
      valioldPass.call(this, rule, value, callback);
    };
    var passFun = (rule, value, callback) => {
      validatePass.call(this, rule, value, callback);
    };
    var checkPassFun = (rule, value, callback) => {
      validatePass2.call(this, rule, value, callback);
    };
    return {
      inputType: "text",
      scopedForm: {
        oldPass: "",
        pass: "",
        checkPass: "",
        oldPhone: "",
        numCode: "",
      },
      rules: {
        oldPass: [{ validator: oldPassFun, trigger: "blur" }],
        pass: [{ validator: passFun, trigger: "blur" }],
        checkPass: [{ validator: checkPassFun, trigger: "blur" }]
      },
      emailForm: {
        oldPass: "",
        pass: "",
        checkPass: "",
        email: "",
        numCode: "",
      },
      emailRules: {
        oldPass: [{ validator: oldPassFun, trigger: "blur" }],
        pass: [{ validator: passFun, trigger: "blur" }],
        checkPass: [{ validator: checkPassFun, trigger: "blur" }]
      },
      validCode: {
        timeMax: 60,
        html: "获取验证码",
        load: "{time}秒后重试",
        _html: "获取验证码",
        _load: false,
        _time: 60,
        _inter: null,
        disabled: false
      },
      appName:""
    };
  },
  created () {
    this.appName = process.env.VUE_APP_NAME;
    if (this.params) {
      this.scopedForm.oldPhone = this.params.phone;
      this.emailForm.email = this.params.email;
    }
  },
  methods: {
    sendSMS () {
      var that = this;
      var verify = true;
      // if (that.scopedForm.newPhone === that.scopedForm.oldPhone) {
      //   that.$message.closeAll();
      //   that.$message({
      //     message: "不能和当前手机号相同哦!",
      //     type: "error"
      //   })
      //   return
      // }

      if (this.params.phone) {
        this.$refs.scopedForm.validateField(["oldPhone", "newPhone"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      } else {

      }

      if (verify) {
        this.setPhone(true)
      }
    },
    setPhone (data) {
      this.validCode._load = true;
      var that = this;
      if (this.params.phone) {
        let params = {
          // oldPhone: this.scopedForm.oldPhone,
          loginPhone: this.scopedForm.oldPhone,
          checkExist: data
        };
        this.catReq1Service("/api/v1/sms/send_verifyCode", params)
          .then(response => {
            if (!response.success) {
              that.validCode._load = false;
              return;
            }
            this.startCountdown();
          })
          .catch(error => {
            this.validCode._load = false;
            this.endCountdown();
          });
      } else {
        let params = {
          // oldPhone: this.scopedForm.oldPhone,
          email: this.emailForm.email,
          platformType: 0
        };
        this.catReq1Service("/user/send_email_code", params)
          .then(response => {
            if (!response.success) {
              that.validCode._load = false;
              return;
            }
            this.startCountdown();
          })
          .catch(error => {
            this.validCode._load = false;
            this.endCountdown();

          });
      }
    },
    startCountdownCore () {
      this.validCode._time--;
      this.validCode._html = this.validCode.load.replace(
        /\{time\}/g,
        ("0000" + this.validCode._time).substr(-2, 2)
      );
    },
    startCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = true;
      this.startCountdownCore();
      this._inter = setInterval(() => {
        this.startCountdownCore();
        if (this.validCode._time <= 0) {
          this.endCountdown();
        }
      }, 1000);
    },
    endCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = false;
      this.validCode._html = this.validCode.html; // 获取验证码
      this.validCode._time = this.validCode.timeMax; // 60
      this.validCode._load = false;
      this.validCode._inter = null;
    },
    resetForm () {
      // 清空
      if (this.$refs.scopedForm) {
        this.$refs.scopedForm.resetFields();
      }
    },
    submit (callback) {
      // 提交
      if (this.params.phone) {
        this.$refs.scopedForm.validate(valid => {
          if (valid) {
            let params, url
            // $privatization 为true时，私有化部署版本
            if (this.$privatization) {
              url = "/api/v1/user/notVerifyResetPassword"
              params = {
                loginPhone: this.scopedForm.oldPhone,
                oldPassword: md5(this.scopedForm.pass),
                password: md5(this.scopedForm.checkPass)
              }
            } else {
              url = "/api/v1/user/resetPassword"
              params = {
                loginPhone: this.scopedForm.oldPhone,
                password: md5(this.scopedForm.pass),
                verificationCode: this.scopedForm.numCode
                // newPass: md5(this.scopedForm.checkPass)
              };
            }

            this.catReq1Service(url, params) // /api/v1/user/update
              .then(response => {
                if (!response.success) {
                  return;
                }
                callback && callback(this.scopedForm);
              })
              .catch(error => {

              });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.emailForm.validate(valid => {
          if (valid) {
            let params, url
            // $privatization 为true时，私有化部署版本
            if (this.$privatization) {
              url = "/api/v1/user/notVerifyResetPassword"
              params = {
                loginPhone: this.emailForm.email,
                oldPassword: md5(this.emailForm.pass),
                password: md5(this.emailForm.checkPass)
              }
            } else {
              url = "/api/v1/user/resetPassword"
              params = {
                loginPhone: this.emailForm.email,
                password: md5(this.emailForm.pass),
                verificationCode: this.emailForm.numCode
                // newPass: md5(this.scopedForm.checkPass)
              };
            }

            this.catReq1Service(url, params) // /api/v1/user/update
              .then(response => {
                if (!response.success) {
                  return;
                }
                callback && callback(this.emailForm);
              })
              .catch(error => {

              });
          } else {
            return false;
          }
        });
      }

    },
    onSubmit () {
      // console.log(this.ifForm, "submit!");
    }
  }
};
function valioldPass (rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    callback();
  }
}
function validatePass (rule, value, callback) {
  // if (value === "") {
  //   callback(new Error("请输入密码"));
  // } else {
  //   if (this.scopedForm.checkPass !== "") {
  //     this.$refs.scopedForm.validateField("checkPass");
  //   }
  //   callback();
  // }
  if (value === "") {
    return callback(new Error("请输入密码"));
  } else if (value.length < 6) {
    callback(new Error("密码长度不能小于6个字符"));
  } else if (value.length > 16) {
    callback(new Error("密码长度不能超过16个字符"));
  }
  callback();
}
function validatePass2 (rule, value, callback) {
  if (this.params.phone) {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.scopedForm.pass) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  } else {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.emailForm.pass) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  }

}
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 360px;
  text-align: left;
  padding: 0 50px;
  .numCode {
    width: 120px;
    &.load {
      width: 110px;
    }
  }
  .numCodeBtn {
    font-size: 12px;
    padding: 12px 15px;
    color: rgba(69, 69, 69, 1);
    border: 1px solid rgba(69, 69, 69, 1);
    float: right;
    height: 36px;
    position: absolute;
    top: 50%;
    right: 0px;
    margin-top: -18px;
  }
}
.scoped-tips {
  padding-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: #999999;
}
</style>